import { render, staticRenderFns } from "./SendNotificationBirthday.vue?vue&type=template&id=1651e955&scoped=true"
import script from "./SendNotificationBirthday.vue?vue&type=script&lang=js"
export * from "./SendNotificationBirthday.vue?vue&type=script&lang=js"
import style0 from "./SendNotificationBirthday.vue?vue&type=style&index=0&id=1651e955&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1651e955",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1651e955')) {
      api.createRecord('1651e955', component.options)
    } else {
      api.reload('1651e955', component.options)
    }
    module.hot.accept("./SendNotificationBirthday.vue?vue&type=template&id=1651e955&scoped=true", function () {
      api.rerender('1651e955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/birthdaymanagement/SendNotificationBirthday.vue"
export default component.exports